/**
 * 教师在线状态mqtt主题前缀
 *
 * <P>
 *  模板：laiwei/mlpen/online_status/teacher/{teacherId}
 * </P>
 */
const teacher_online_status_topic_prefix = 'laiwei/mlpen/online_status/teacher/'

/**
 * 班级活动状态指令mqtt主题前缀
 * <P>
 *  模板：laiwei/mlpen/class_activity/status/teacher/{classId}
 * </P>
 */
const class_activity_status_topic_prefix = 'laiwei/mlpen/class_activity/status/teacher/'

/**
 * 自由活动状态指令mqtt主题前缀
 * <P>
 *  模板：laiwei/mlpen/class_activity/status/free/{classroomId}
 * </P>
 */
const free_activity_status_topic_prefix = 'laiwei/mlpen/class_activity/status/free/'


/**
 * 班级活动聊天信息mqtt主题前缀
 * <P>
 *  模板：laiwei/mlpen/class_activity/chat_message/{activityId}
 * </P>
 */
const class_activity_chat_message_topic_prefix = 'laiwei/mlpen/class_activity/chat_message/'

/**
 * 班级活动公告信息mqtt主题前缀
 *
 * <P>
 *  模板：laiwei/mlpen/class_activity/announcement/{activityId}
 * </P>
 */
const class_activity_announcement_topic_prefix = 'laiwei/mlpen/class_activity/announcement/'

/**
 * 班级活动互踢消息mqtt主题签注
 *
 * <P>
 *  模板：laiwei/mlpen/class_activity/forced_kick/{classId}
 * </P>
 */
const class_activity_forced_kick_topic_prefix = 'laiwei/mlpen/class_activity/forced_kick/'

export {
  teacher_online_status_topic_prefix,
  class_activity_status_topic_prefix,
  class_activity_chat_message_topic_prefix,
  class_activity_announcement_topic_prefix,
  class_activity_forced_kick_topic_prefix,
  free_activity_status_topic_prefix
}
